import React from "react";
import styled from "styled-components";

const Highlight = styled.span`
  color: ${(props) => props.theme.palette.yellow.light};
  background-color: ${(props) => props.theme.palette.secondary.main};

  padding: 2px 10px;
  border-radius: ${(props) => props.theme.border.radius};
`;

const DonateeInfo = (props) => {
  return props.donateeInfo.id ? (
    <div>
      <Highlight>{`£ ${props.donateeInfo.amount}`}</Highlight>
      <span>{` from ${props.donateeInfo.name}`}</span>
    </div>
  ) : (
    <div>
      <Highlight>{props.forestDonations.length}</Highlight>
      <span> people have donated so far!</span>
    </div>
  );
};

export default DonateeInfo;
